import { render } from "./Nabvar_Top.vue?vue&type=template&id=a88dacac&scoped=true"
import script from "./Nabvar_Top.vue?vue&type=script&lang=js"
export * from "./Nabvar_Top.vue?vue&type=script&lang=js"

import "./Nabvar_Top.vue?vue&type=style&index=0&id=a88dacac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88dacac"]])

export default __exports__